module.exports = __webpack_public_path__ + "static/media/bestbuyicon.03f8331c.svg";